module.exports = "query IssuesCustomizeIssueSummaryQuery{issueSummaryPredefinedMessages{edges{node{id rowId title message sortOrder}}}}"